import { GraphObject, Group, InputEvent } from 'gojs';
import { highlightGroupTree } from '../../../utils/highlight-utils';

export const groupMouseHover = (e: InputEvent, group: GraphObject) => {
  try {
    e.diagram.clearHighlighteds();
    highlightGroupTree(group as Group);
  } catch (err) {
    e.diagram.clearHighlighteds();
  }
};

export const groupMouseLeave = (e: InputEvent) => {
  e.diagram.clearHighlighteds();
};
